import { Component } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

@Component({
	selector: 'ui-view-container',
	template: '<div ui-view></div>',
	standalone: true,
	imports: [
		UIRouterModule
	]
})
export class UiViewContainerComponent {

}
